import React, { useEffect, useState } from "react";
import {
  tableImg,
  tableImg2,
  messageIconBlack,
} from "../../../../constant/imagePath";
import { AdminTable } from "../../../../stories/AdminTable/AdminTable";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import { useHistory, useLocation, Link } from "react-router-dom";

import { InputWithSearchIcon } from "../../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { SideBarMenu } from "../../../../stories/SideBarMenu/SideBarMenu";
import classes from "./User.module.css";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { Container, Row, Col } from "react-bootstrap";
import UnBanModal from "../../../../components/Modals/Admin/UnBanModal/UnBanModal";
import BanExplanationModal from "../../../../components/Modals/Admin/BanExplanationModal/BanExplanationModal";
import UserDetailModal from "../../../../components/Modals/Admin/UserDetailModal/UserDetailModal";
import MessageDetailsModal from "../../../../components/Modals/Admin/MessageDetailsModal/MessageDetailsModal";
import dropdownClasses from "../../../../stories/DropDown/DropDown.module.css";
import Layout from "../../Layout/Layout";
import { TableCell, TableRow } from "@mui/material";
import { Button } from "../../../../stories/Button/Button";

const User = () => {
  const [showUnban, setShowUnban] = useState(false);
  const [showUserDetail, setShowUserDetails] = useState(false);
  const [showBanMsg, setShowBanMsg] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [location1, setLocation1] = useState();

  // DropDown States
  const [cancellations, setCancellations] = useState();
  const [status, setStatus] = useState();
  const [rating, setRating] = useState({ label: "All Rates", value: "all" });
  const [userType, setUserType] = useState({ label: "All", value: "all" });

  const dummy = [
    {
      image: tableImg,
      name: "Ann Johnson",
      role: "student",
      cancel: 3,
      lastCancel: "medical emergency",
      rating: 5.0,
      status: "Banned",
      chat: "messageIconBlack",
    },
    {
      image: tableImg,
      name: "Ann Johnson",
      role: "student",
      cancel: 3,
      lastCancel: "medical emergency",
      rating: 5.0,
      status: "Banned",
      chat: "messageIconBlack",
    },
    {
      image: tableImg,
      name: "Ann Johnson",
      role: "student",
      cancel: 3,
      lastCancel: "medical emergency",
      rating: 4.5,
      status: "Banned",
      chat: "messageIconBlack",
    },
    {
      image: tableImg,
      name: "Ann Johnson",
      role: "student",
      cancel: 3,
      lastCancel: "medical emergency",
      rating: 2.3,
      status: "Banned",
      chat: "messageIconBlack",
    },
    {
      image: tableImg,
      name: "Ann Johnson",
      role: "student",
      cancel: 3,
      lastCancel: "medical emergency",
      rating: 4.9,
      status: "Banned",
      chat: "messageIconBlack",
    },
    {
      image: tableImg2,
      name: "Sarika Bhimre",
      role: "student",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 3.2,
      status: "Banned",
      chat: messageIconBlack,
    },
    {
      image: tableImg2,
      name: "Kate Smith",
      role: "student",
      cancel: 2,
      lastCancel: "medical emergency",
      rating: 4.7,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "John White",
      role: "coach",
      cancel: 2,
      lastCancel: "Weather",
      rating: 3.9,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg2,
      name: "Peter Parker",
      role: "student",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 2.5,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg2,
      name: "Jon Snow",
      role: "coach",
      cancel: 2,
      lastCancel: "Weather",
      rating: 1.0,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Anthony Kiedis",
      role: "coach",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 4.9,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Alex Turner",
      role: "coach",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 4.5,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Alex Turner",
      role: "coach",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 4.1,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Alex Turner",
      role: "coach",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 4.3,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Alex Turner",
      role: "coach",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 3.0,
      status: "Active",
      chat: messageIconBlack,
    },
    {
      image: tableImg,
      name: "Alex Turner",
      role: "coach",
      cancel: 3,
      lastCancel: "Unspecified",
      rating: 4.1,
      status: "Active",
      chat: messageIconBlack,
    },
  ];
  const tableHeadings = [
    { title: "User Name" },
    { title: "User type" },
    { title: "Cancellation", filter: true },
    { title: "Last Cancellation Reason" },
    { title: "Rating", filter: true },
    { title: "Status" },
  ];
  const [data, setData] = useState(dummy);
  const [dataCopy, setDataCopy] = useState(data);
  const [filterData, setFilterData] = useState(data);

  useEffect(() => {
    if (rating?.value == "all") {
      setFilterData(data);
      return;
    }
    setFilterData(
      data?.filter((item) => Math.floor(item?.rating) == rating?.value)
    );
  }, [rating]);
  return (
    <>
      <style>{`
      .${dropdownClasses.reactSelect} > div {
        z-index: 3;
      }
    }`}</style>
      <div className={classes.AdminTableMain}>
        {/* Layout */}
        <Layout location1={location1} />
        <div className={classes.tableMain}>
          <Container fluid className={classes.container}>
            <h3
              className={classes.marginBlock24}
              style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
            >
              User Management
            </h3>
            <Row>
              <Col md={4}>
                <InputWithSearchIcon />
              </Col>
              <Col md={2}>
                <DropDown
                  state={cancellations}
                  setter={setCancellations}
                  placeholder={"Cancellations"}
                />
              </Col>
              <Col md={2}>
                <DropDown
                  state={status}
                  setter={setStatus}
                  placeholder={"Status"}
                  options={[
                    { label: "All", value: "all" },
                    { label: "Pending", value: "pending" },
                    { label: "Solved", value: "solved" },
                  ]}
                />
              </Col>
              <Col md={2}>
                <DropDown
                  state={rating}
                  setter={setRating}
                  placeholder={"Rating"}
                  options={[
                    { label: "All Rates", value: "all" },
                    { label: "1 star", value: "1" },
                    { label: "2 stars", value: "2" },
                    { label: "3 stars", value: "3" },
                    { label: "4 stars", value: "4" },
                    { label: "5 stars", value: "5" },
                  ]}
                />
              </Col>
              <Col md={2}>
                <DropDown
                  state={userType}
                  setter={setUserType}
                  placeholder={"User Type"}
                  options={[
                    { label: "All", value: "all" },
                    { label: "Student", value: "student" },
                    { label: "Coach", value: "coach" },
                  ]}
                />
              </Col>
            </Row>
            <div className={classes.overflowScroll630}>
              <AdminTable
                headings={tableHeadings}
                renderDataWithElement={data?.map(item => {
                  return (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <div className={classes.tableImg} onClick={() => setShowUserDetails(true)}>
                          <div
                            className={classes.innerImgCont}
                          >
                            <img src={item?.image} alt="tableImg" />
                          </div>
                          <h6
                            style={{
                              ...Fonts.b3,
                              color: Colors.neutralShadesOfNero,
                            }}
                          >
                            {" "}
                            {item?.name}
                          </h6>
                        </div>
                      </TableCell>

                      <TableCell>
                        <p
                          style={{
                            ...Fonts.b1Mobile,
                            color: Colors.neutralShadesOfNero,
                            textTransform: "capitalize",
                          }}
                        >
                          {item?.role}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p
                          style={{
                            ...Fonts.b1Mobile,
                            color:
                              item?.cancel == 3
                                ? Colors.additionalShadesOfKellyGreen1
                                : item?.cancel !== 3 && Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.cancel}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p
                          style={{
                            ...Fonts.b1Mobile,
                            color:
                              item?.lastCancel == "Unspecified"
                                ? Colors.deActiveColor
                                : item?.lastCancel !== "" &&
                                Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.lastCancel}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p
                          style={{
                            ...Fonts.b1Mobile,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.rating?.toFixed(1)}
                        </p>
                      </TableCell>
                      <TableCell>
                        <div className={classes.chatAndBanndWrapper}>
                          <div className={classes.banned} onClick={() => {
                            if (item.status == 'Banned') {
                              setShowUnban(true)
                            } else {
                              setShowBanMsg(true)
                            }
                          }}>
                            <p
                              style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}
                              className={
                                item?.status?.toLowerCase() == "active"
                                  ? classes.tableCells
                                  : classes.tableCellsGreen
                              }
                            >
                              {item?.status}
                            </p>
                          </div>

                          <Button
                            icon={messageIconBlack}
                            size="Medium"
                            onClick={() => setShowMsg(true)}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                })}
              />{" "}
            </div>
          </Container>
        </div>
      </div>
      <UnBanModal show={showUnban} setShow={setShowUnban} />
      <BanExplanationModal show={showBanMsg} setShow={setShowBanMsg} />
      <MessageDetailsModal show={showMsg} setShow={setShowMsg} />
      <UserDetailModal show={showUserDetail} setShow={setShowUserDetails} />
    </>
  );
};

export default User;
